import { Node_Type } from '@wix/ricos';
export const createRicosThemeWithCssVars = (isMobile = false, fallbackColor) => {
    return {
        palette: {
            type: 'rgb',
            bgColor: toCssVar('--postBackgroundColor'),
            textColor: toCssVar('--textParagraphColor-rgb'),
            actionColor: toCssVar('--postButtonBackgroundColor'),
            textOnActionColor: toCssVar('--postButtonTextColor'),
            fallbackColor,
        },
        paletteConfig: {
            contentBgColor: undefined,
            settingsActionColor: fallbackColor,
            focusActionColor: fallbackColor,
        },
        customStyles: {
            h1: toRicosCustomTextStyle('--textH1Font', '--textH1Color'),
            h2: toRicosCustomTextStyle('--textH2Font', '--textH2Color'),
            h3: toRicosCustomTextStyle('--textH3Font', '--textH3Color'),
            h4: toRicosCustomTextStyle('--textH4Font', '--textH4Color'),
            h5: toRicosCustomTextStyle('--textH5Font', '--textH5Color'),
            h6: toRicosCustomTextStyle('--textH6Font', '--textH6Color'),
            link: {
                fontStyle: 'inherit',
                fontWeight: 'inherit',
                textDecoration: 'inherit',
                color: toCssColorVar('--textLinksAndHashtagsColor'),
            },
            hashtag: {
                fontStyle: 'inherit',
                fontWeight: 'inherit',
                textDecoration: 'inherit',
                color: toCssColorVar('--textLinksAndHashtagsColor'),
            },
            quote: {
                ...toRicosCustomTextStyle('--textQuoteFont', '--textQuoteColor'),
                borderColor: toCssColorVar('--textLinksAndHashtagsColor'),
                marginInlineStart: 'var(--ricosQuoteMarginInlineStart)',
            },
            p: toRicosCustomTextStyle('--textParagraphFont', '--textParagraphColor'),
            footerToolbar: {
                paddingInlineStart: 'var(--ricosFooterPadding)',
                paddingInlineEnd: 'var(--ricosFooterPadding)',
            },
            editor: {
                addPluginButton: {
                    positionInlineStart: 'var(--ricosAddPluginButtonStart)',
                },
            },
        },
        breakout: isMobile ? ricosBreakoutConfigMobile : ricosBreakoutConfig,
        settingsStyles: {
            modals: isMobile
                ? {
                    toolbarZIndex: 9999999999,
                    popupZIndex: 9999999999,
                    drawerZIndex: 9999999999,
                    dialogZIndex: 9999999999,
                    tooltipZIndex: 9999999999,
                    notificationZIndex: 9999999999,
                }
                : undefined,
        },
    };
};
export const createRicosThemeWithCssVarsForPaywall = () => {
    return {
        palette: {
            type: 'rgb',
            actionColor: toCssVar('--postButtonBackgroundColor'),
            bgColor: toCssVar('--postButtonTextColor'),
        },
        customStyles: {
            h3: toRicosCustomTextStyle('--textH1Font', '--textH1Color', true),
            p: toRicosCustomTextStyle('--textParagraphFont', '--textParagraphColor', true),
        },
    };
};
const toCssColorVar = (param) => `rgb(var(${param}))`;
const toCssVar = (param) => `var(${param})`;
const toRicosCustomTextStyle = (cssFontVar, cssColorVar, onlyFamilyAndColor) => {
    const adjustLineHeightForParagraph = cssFontVar === '--textParagraphFont';
    return {
        ...(onlyFamilyAndColor
            ? { fontFamily: `var(${cssFontVar}-family)`, color: toCssColorVar(cssColorVar) }
            : {
                fontSize: `var(${cssFontVar}-size)`,
                fontStyle: `var(${cssFontVar}-style)`,
                fontFamily: `var(${cssFontVar}-family)`,
                fontWeight: `var(${cssFontVar}-weight)`,
                textDecoration: `var(${cssFontVar}-text-decoration)`,
                lineHeight: adjustLineHeightForParagraph
                    ? `max(calc(var(${cssFontVar}-size) * 1.5), var(${cssFontVar}-line-height))`
                    : `var(${cssFontVar}-line-height)`,
                color: toCssColorVar(cssColorVar),
            }),
    };
};
const ricosBreakoutConfig = {
    rule: ({ node }) => {
        const isLayout = node.type === Node_Type.LAYOUT;
        const isFullWidthImage = node.type === Node_Type.IMAGE && node.imageData?.containerData?.width?.size === 'FULL_WIDTH';
        const isFullWidthGif = node.type === Node_Type.GIF && node.gifData?.containerData?.width?.size === 'FULL_WIDTH';
        const isFullWidthGallery = node.type === Node_Type.GALLERY &&
            node.galleryData?.containerData?.width?.size === 'FULL_WIDTH';
        const isFullWidthVideo = node.type === Node_Type.VIDEO && node.videoData?.containerData?.width?.size === 'FULL_WIDTH';
        const isFullWidth = [
            isFullWidthImage,
            isFullWidthGif,
            isFullWidthGallery,
            isFullWidthVideo,
            isLayout,
        ].includes(true);
        if (isFullWidth) {
            return 'fullWidth';
        }
        return 'normal';
    },
    normalPadding: {
        start: 'var(--ricosNormalPadding)',
        end: 'var(--ricosNormalPadding)',
    },
    fullWidthPadding: {
        start: 'var(--ricosFullWidthPadding)',
        end: 'var(--ricosFullWidthPadding)',
    },
};
const ricosBreakoutConfigMobile = {
    normalPadding: ricosBreakoutConfig.normalPadding,
    fullWidthPadding: ricosBreakoutConfig.fullWidthPadding,
    rule: ({ node }) => {
        const nodesToBreakout = [
            Node_Type.AUDIO,
            Node_Type.BLOCKQUOTE,
            Node_Type.CODE_BLOCK,
            Node_Type.COLLAPSIBLE_ITEM,
            Node_Type.COLLAPSIBLE_LIST,
            Node_Type.EMBED,
            Node_Type.FILE,
            Node_Type.HTML,
            Node_Type.LINK_PREVIEW,
            Node_Type.POLL,
            Node_Type.TABLE,
            Node_Type.LAYOUT,
        ];
        if (nodesToBreakout.includes(node.type)) {
            return 'fullWidth';
        }
        return ricosBreakoutConfig.rule({ node });
    },
};
//# sourceMappingURL=ricos-theme.js.map